import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import { useFeedbackTerminology } from '@/entities/workspace';

type Props = {
  reclassifyOnly: boolean;
  onAISuggestionClick: () => void;
  onReclassifyClick: () => void;
  count: number;
};

const AiTopicCreateGuide = (props: Props) => {
  const { replaceFeedbackTerminology } = useFeedbackTerminology();

  return (
    <Style j="space-between" a="center">
      <Typo type="body2" weight="m">
        {replaceFeedbackTerminology(
          `You have ${props.count} outstanding feedback.`,
        )}{' '}
        {!props.reclassifyOnly && 'Ask Syncly to suggest how to classify them.'}
      </Typo>
      <Flex g={8}>
        <Button
          tooltip="Re-classify feedback based on the latest topic settings."
          variant="outlined"
          onClick={props.onReclassifyClick}
          rightIcon={<InfoCircleOutlined />}
        >
          Re-classify
        </Button>
        {!props.reclassifyOnly && (
          <Button variant="primary" onClick={props.onAISuggestionClick}>
            See suggestions
          </Button>
        )}
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  padding: 8px 12px;
  color: ${(props) => props.theme.colors.gray700};
  border-radius: ${(props) => props.theme.radius.token.sm}px;
  background-color: ${(props) => props.theme.colors.selected};
`;

export default AiTopicCreateGuide;
